// import React, { useEffect, useState } from "react";
// import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
// import axios from "axios";
// import HOST_URL from "../../../utils/Url";
// import Card from "@mui/material/Card";
// import { Box, Button, Divider, Stack, Typography } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import Switch from "@mui/material/Switch";
// import { useNavigate, useLocation } from "react-router-dom";
// import Chip from "@mui/material/Chip";
// import { useTranslation } from "react-i18next";
// import Paper from "@mui/material/Paper";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import CircularProgress from "@mui/material/CircularProgress";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import FileDetailSwipeableDrawer from "./FileDetailSwipeableDrawer";
// import { getSecureDevId, getSecureSubDeptId } from "../../../utils/storageHelpers";
// import PublishIcon from "@mui/icons-material/Publish";
// import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
// import { secureGetItem } from "../../../utils/encryption";

// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
//   isDel: boolean;
//   isView: boolean;
//   isExport?: boolean; // Optional, add if export permission is needed
// }

// export default function DocumentEntry() {
//   const [excelModalOpen, setExcelModalOpen] = useState(false);
// const [selectedExcelFile, setSelectedExcelFile] = useState<File | null>(null);
// const [importLoading, setImportLoading] = useState(false);

//   const [zones, setZones] = useState([]);
//   const [columns, setColumns] = useState<any>([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const location = useLocation();
//   const [permissionLoaded, setPermissionLoaded] = useState(false);
//   const [permissionData, setPermissionData] = useState<MenuPermission>({
//     isAdd: false,
//     isEdit: false,
//     isPrint: false,
//     isDel: false,
//     isView:false,
//     isExport:false
//   });
//   const [DocDetailData, setDocDetailData] = useState<any>(null);
//   const [DocDetailRecords, setDocDetailRecords] = useState<any>(null);
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   const subDeptID = getSecureSubDeptId();
//   let navigate = useNavigate();
//   const { t } = useTranslation();

//  useEffect(() => {
//    const data = secureGetItem("userdata");   // ✅ decrypt + parse

//    if (data && data.length > 0) {
//      const userPermissionData = data[0]?.userPermission;
//      const menudata = userPermissionData?.[0]?.parentMenu || [];

//      for (let i = 0; i < menudata.length; i++) {
//        const childMenudata = menudata[i]?.childMenu || [];
//        const pathrow = childMenudata.find(
//          (x: any) => x.path === location.pathname
//        );

//        if (pathrow) {
//          setPermissionData({
//            isAdd: pathrow.isAdd,
//            isEdit: pathrow.isEdit,
//            isPrint: pathrow.isPrint,
//            isDel: pathrow.isDel,
//             isView: pathrow.isView,
//             isExport: pathrow.isExport 
//          });
//          break;
//        }
//      }
//    }
//  setPermissionLoaded (true);
//    // fetchZonesData();
//  }, [location.pathname]);
//   // }, [isLoading]);
//   const routeChangeAdd = () => {
//     let path = `/DocManagement/DocumentEntryAdd`;
//     navigate(path);
//   };


//   const routeChangeEdit = (row: any) => {
//     let path = `/DocManagement/DocumentEntryEdit`;
//     navigate(path, {
//       state: row,
//     });
//   };
// // 🔵 Select Excel File
// const handleExcelFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
//   const file = event.target.files?.[0];
//   if (!file) return;

//   if (!file.name.match(/\.(xlsx|xls)$/)) {
//     toast.error("Please select a valid Excel file (.xlsx or .xls)");
//     return;
//   }

//   setSelectedExcelFile(file);
//   setExcelModalOpen(true);
// };

// // 🔵 Final Import API Call
// const handleFinalExcelImport = async () => {
//   if (!selectedExcelFile) {
//     toast.error("No file selected");
//     return;
//   }

//   setImportLoading(true);

//   try {
//     const data = secureGetItem("userdata");
//     const formData = new FormData();

//     formData.append("file", selectedExcelFile);
//     formData.append("FileName", selectedExcelFile.name);
//     formData.append("userId", data[0].useR_ID);

//     const response = await axios.post(
//       `${HOST_URL.HOST_URL}Import/ImportExcel`,
//       formData
//     );

//     if (response.data.success) {
//       toast.success(response.data.message || "Excel imported successfully");
//       fetchZonesData();
//     } else {
//       toast.error(response.data.message || "Import failed");
//     }
//   } catch (err) {
//     toast.error("Error importing Excel");
//   } finally {
//     setImportLoading(false);
//     setExcelModalOpen(false);
//     setSelectedExcelFile(null);
//   }
// };

//   let delete_id = "";

//   const accept = () => {
//     const collectData = {
//       docMid: delete_id,
//       userID: 0,
//     };
//     console.log("collectData " + JSON.stringify(collectData));
//     axios
//       .post(HOST_URL.HOST_URL2 + `DocMangr/DeleteDocMangr`, 
//        collectData
//       )
//       .then((response) => {
//         if (response.data.isSuccess) {
//           toast.success(response.data.mesg);
//         } else {
//           toast.error(response.data.mesg);
//         }
//         fetchZonesData();
//       });
//   };

//   const reject = () => {
//     // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
//     toast.warn("Rejected: You have rejected", { autoClose: 3000 });
//   };
//       useEffect(() => {
//         if(permissionLoaded){
//       fetchZonesData();
//         }
//     }, [permissionLoaded]); 

//   const handledeleteClick = (del_id: any) => {
//     // console.log(del_id + " del_id ");
//     delete_id = del_id;
//     confirmDialog({
//       message: "Do you want to delete this record ?",
//       header: "Delete Confirmation",
//       icon: "pi pi-info-circle",
//       acceptClassName: "p=-button-danger",
//       accept,
//       reject,
//     });
//   };

//   const getDocMngRecords = async (id: any) => {
//     // setIsReportLoading(true);
//     const collectData = {
//       docMid: id,
//         fileTypId: -1,
//         divisionid: -1,
//         subsubjId: -1,
//         user_Id: -1,
//         fileNo: "",
//         subDeptID: -1,
//         synopsis: "",
//         complt: ""
//     }
//     console.log("collectData", collectData);

//     const response = await axios.post(
//       HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
//       collectData
//     );

//     console.log("getData", response.data.data);
//     setDocDetailData(response.data.data[0]["fileNo"] + " - " + response.data.data[0]["fileType_Name"])
//     setDocDetailRecords(response.data.data);
//     setDrawerOpen(true);
//   }


// const devId = getSecureDevId();



//   const fetchZonesData = async () => {
//     try {
//       const collectData = {
//         docMid: -1,
//         fileTypId: -1,
//         //@ts-ignore
//         divisionid: devId === "null" ? -1 : devId,
//         subsubjId: -1,
//         user_Id: -1,
//         fileNo: "",
//         subDeptID: subDeptID == null ? -1 : subDeptID,
//         synopsis: "",
//         complt: ""
//       };
//       console.log("collectData", collectData);
//       const response = await axios.post(
//         HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
//         collectData
//       );
//       console.log("result", response.data.data);
//       const data = response.data.data;
//       const zonesWithIds = data.map((doc: any, index: any) => ({
//         ...doc,
//         serialNo: index + 1,
//         id: doc.docMid,
//       }));

//       setZones(zonesWithIds);
//       setIsLoading(false);

//       if (data.length > 0) {
//     const actionColumn: GridColDef[] =
//   permissionData?.isEdit || permissionData?.isDel || permissionData?.isView
//     ? [
//         {
//           field: "actions",
//           headerClassName: "MuiDataGrid-colCell",
//           headerName: t("text.Action"),
//           width: 180,
//           renderCell: (params) => (
//             <Stack
//               spacing={1}
//               direction="row"
//               sx={{ alignItems: "center", marginTop: "5px" }}
//             >
//               {permissionData?.isEdit && (
//                 <EditIcon
//                   style={{ fontSize: "20px", color: "blue", cursor: "pointer" }}
//                   onClick={() => routeChangeEdit(params.row)}
//                 />
//               )}

//               {permissionData?.isDel && (
//                 <DeleteIcon
//                   style={{ fontSize: "20px", color: "red", cursor: "pointer" }}
//                   onClick={() => handledeleteClick(params.row.id)}
//                 />
//               )}

//               {permissionData?.isView && (
//                 <VisibilityIcon
//                   style={{ fontSize: "20px", color: "#1976d2", cursor: "pointer" }}
//                   onClick={() => getDocMngRecords(params.row.id)}
//                 />
//               )}
//             </Stack>
//           ),
//         },
//       ]
//     : [];
//         const columns: GridColDef[] = [
//           ...actionColumn,
//           // {
//           //   field: "actions",
//           //   headerClassName: "MuiDataGrid-colCell",
//           //   headerName: t("text.Action"),
//           //   width: 150,

//           //   renderCell: (params) => {
//           //     return [
//           //       <Stack
//           //         spacing={1}
//           //         direction="row"
//           //         sx={{ alignItems: "center", marginTop: "5px" }}
//           //       >
//           //         {/* {permissionData?.isEdit ? ( */}
//           //         <EditIcon
//           //           style={{
//           //             fontSize: "20px",
//           //             color: "blue",
//           //             cursor: "pointer",
//           //           }}
//           //           className="cursor-pointer"
//           //           onClick={() => routeChangeEdit(params.row)}
//           //         />

//           //         <DeleteIcon
//           //           style={{
//           //             fontSize: "20px",
//           //             color: "red",
//           //             cursor: "pointer",
//           //           }}
//           //           onClick={() => {
//           //             handledeleteClick(params.row.id);
//           //           }}
//           //         />
//           //         {/* ) : ( */}
//           //         {/*  "" */}
//           //         {/* )} */}
//           //         <VisibilityIcon
//           //           style={{
//           //             fontSize: "20px",
//           //             color: "blue",
//           //             cursor: "pointer",
//           //           }}
//           //           onClick={() => {
//           //             getDocMngRecords(params.row.id);
//           //           }}
//           //         />
//           //       </Stack>,
//           //     ];
//           //   },
//           // },
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             minWidth: 60
//           },
//           {
//             field: "fileNo",
//             headerName: t("text.FileNo"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             minWidth: 140
//           },

//           {
//             field: "synopsis",
//             headerName: t("text.FileName"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             minWidth: 140
//           },
//           {
//             field: "fileDef",
//             headerName: t("text.FileDef"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             minWidth: 140
//           },
//         ];
//         setColumns(columns as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       // setLoading(false);
//     }
//   };

//   const adjustedColumns = columns.map((column: any) => ({
//     ...column,
//   }));

//   return (
//     <>
//       <Card
//         style={{
//           width: "100%",
//           // height: "100%",
//           backgroundColor: "#E9FDEE",
//           // border: ".5px solid #FF7722 ",
//           marginTop: "3vh",
//         }}
//       >
//         <Paper
//           sx={{
//             width: "100%",
//             overflow: "hidden",
//             "& .MuiDataGrid-colCell": {
//               backgroundColor: `var(--grid-headerBackground)`,
//               color: `var(--grid-headerColor)`,
//               fontSize: 17,
//               fontWeight: 900
//             },
//           }}
//           style={{ padding: "10px", }}
//         >
//           <ConfirmDialog />

//           <Typography
//             gutterBottom
//             variant="h5"
//             component="div"
//             sx={{ padding: "20px" }}
//             align="left"
//           >
//             {t("text.DocumentEntry")}
//           </Typography>
//           <Divider />

//           <Box height={10} />

//   <Stack direction="row" spacing={2} classes="my-2 mb-2">
//      {permissionData?.isAdd == true && (
//   <Button
//     onClick={routeChangeAdd}
//     variant="contained"
//     endIcon={<AddCircleIcon />}
//     size="large"
//     style={{ backgroundColor: `var(--header-background)` }}
//   >
//     {t("text.add")}
//   </Button>
//      )}

//   {/* 🔵 Excel Import Button */}
//    {permissionData?.isExport == true && (
//   <Button
//     component="label"
//     variant="contained"
//     endIcon={<PublishIcon />}
//     size="large"
//     style={{ backgroundColor: `var(--header-background)` }}
//     disabled={importLoading}
//   >
//     {importLoading ? "Importing..." : t("text.ImportExcel")}
//     <input
//       type="file"
//       hidden
//       accept=".xlsx,.xls"
//       onChange={handleExcelFileSelect}
//     />
//   </Button>
//    )}
// </Stack>


//           <FileDetailSwipeableDrawer
//             open={drawerOpen}
//             onClose={() => setDrawerOpen(false)}
//             title={`# ${DocDetailData}  `}
//             userData={DocDetailRecords}
//           />

//           {isLoading ? (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <CircularProgress />
//             </div>
//           ) : (
//             <Box>
//               <br />
//               <div style={{ width: "100%", backgroundColor: `var(--grid-background)` }}>
//                 <DataGrid
//                   rows={zones}
//                   columns={adjustedColumns}
//                   autoHeight
//                   slots={{
//                     toolbar: GridToolbar,
//                   }}
//                   rowSpacingType="border"
//                   pagination={true}
//                   pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
//                     value: size,
//                     label: `${size}`,
//                   }))}
//                   initialState={{
//                     pagination: { paginationModel: { pageSize: 5 } },
//                   }}
//                   slotProps={{
//                     toolbar: {
//                       showQuickFilter: true,
//                     },
//                   }}
//                 />
//               </div>
//             </Box>
//           )}
//         </Paper>
//       </Card>
//       <Dialog open={excelModalOpen} onClose={() => setExcelModalOpen(false)}>
//   <DialogTitle>Confirm Excel Import</DialogTitle>

//   <DialogContent>
//     <Typography>
//       Selected File: <strong>{selectedExcelFile?.name}</strong>
//     </Typography>
//     <Typography mt={1}>
//       Click <strong>Import</strong> to upload this Excel file.
//     </Typography>
//   </DialogContent>

//   <DialogActions>
//     <Button color="error" onClick={() => setExcelModalOpen(false)}>
//       Cancel
//     </Button>

//     <Button
//       variant="contained"
//       onClick={handleFinalExcelImport}
//       disabled={importLoading}
//       style={{ backgroundColor: `var(--header-background)` }}
//     >
//       {importLoading ? "Importing..." : "Import"}
//     </Button>
//   </DialogActions>
// </Dialog>

//       <ToastApp />
//     </>
//   );
// }


import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Card from "@mui/material/Card";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDetailSwipeableDrawer from "./FileDetailSwipeableDrawer";
import { getSecureDevId, getSecureSubDeptId } from "../../../utils/storageHelpers";
import PublishIcon from "@mui/icons-material/Publish";
import DownloadIcon from "@mui/icons-material/Download";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { secureGetItem } from "../../../utils/encryption";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
  isView: boolean;
  isExport?: boolean; // Optional, add if export permission is needed
}

export default function DocumentEntry() {
  const [excelModalOpen, setExcelModalOpen] = useState(false);
  const [selectedExcelFile, setSelectedExcelFile] = useState<File | null>(null);
  const [importLoading, setImportLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const [zones, setZones] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [permissionLoaded, setPermissionLoaded] = useState(false);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
    isView: false,
    isExport: false
  });
  const [DocDetailData, setDocDetailData] = useState<any>(null);
  const [DocDetailRecords, setDocDetailRecords] = useState<any>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const subDeptID = getSecureSubDeptId();
  let navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const data = secureGetItem("userdata");   // ✅ decrypt + parse

    if (data && data.length > 0) {
      const userPermissionData = data[0]?.userPermission;
      const menudata = userPermissionData?.[0]?.parentMenu || [];

      for (let i = 0; i < menudata.length; i++) {
        const childMenudata = menudata[i]?.childMenu || [];
        const pathrow = childMenudata.find(
          (x: any) => x.path === location.pathname
        );

        if (pathrow) {
          setPermissionData({
            isAdd: pathrow.isAdd,
            isEdit: pathrow.isEdit,
            isPrint: pathrow.isPrint,
            isDel: pathrow.isDel,
            isView: pathrow.isView,
            isExport: pathrow.isExport
          });
          break;
        }
      }
    }
    setPermissionLoaded(true);
    // fetchZonesData();
  }, [location.pathname]);
  // }, [isLoading]);

  const routeChangeAdd = () => {
    let path = `/DocManagement/DocumentEntryAdd`;
    navigate(path);
  };

  const routeChangeEdit = (row: any) => {
    let path = `/DocManagement/DocumentEntryEdit`;
    navigate(path, {
      state: row,
    });
  };

  // 🔵 Select Excel File
  const handleExcelFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/)) {
      toast.error("Please select a valid Excel file (.xlsx or .xls)");
      return;
    }

    setSelectedExcelFile(file);
    setExcelModalOpen(true);
  };

  // 🔵 Download Template
  const handleDownloadTemplate = async () => {
    setDownloadLoading(true);
    try {
      const response = await axios.get(
        `https://csadmsapi.mssplonline.com/api/Import/DownloadTemplate`,
        {
          responseType: 'blob', // Important for file download
        }
      );

      // Create a blob URL and trigger download
      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      // Get filename from Content-Disposition header or use default
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'Excel_Template.xlsx';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Template downloaded successfully");
    } catch (error) {
      console.error("Error downloading template:", error);
      toast.error("Failed to download template");
    } finally {
      setDownloadLoading(false);
    }
  };

  // 🔵 Final Import API Call
  const handleFinalExcelImport = async () => {
    if (!selectedExcelFile) {
      toast.error("No file selected");
      return;
    }

    setImportLoading(true);

    try {
      const data = secureGetItem("userdata");
      const formData = new FormData();

      formData.append("file", selectedExcelFile);
      formData.append("FileName", selectedExcelFile.name);
      formData.append("userId", data[0].useR_ID);

      const response = await axios.post(
        `${HOST_URL.HOST_URL}Import/ImportExcel`,
        formData
      );

      if (response.data.success) {
        toast.success(response.data.message || "Excel imported successfully");
        fetchZonesData();
      } else {
        toast.error(response.data.message || "Import failed");
      }
    } catch (err) {
      toast.error("Error importing Excel");
    } finally {
      setImportLoading(false);
      setExcelModalOpen(false);
      setSelectedExcelFile(null);
    }
  };

  let delete_id = "";

  const accept = () => {
    const collectData = {
      docMid: delete_id,
      userID: 0,
    };
    console.log("collectData " + JSON.stringify(collectData));
    axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/DeleteDocMangr`,
        collectData
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        fetchZonesData();
      });
  };

  const reject = () => {
    // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  useEffect(() => {
    if (permissionLoaded) {
      fetchZonesData();
    }
  }, [permissionLoaded]);

  const handledeleteClick = (del_id: any) => {
    // console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const getDocMngRecords = async (id: any) => {
    // setIsReportLoading(true);
    const collectData = {
      docMid: id,
      fileTypId: -1,
      divisionid: -1,
      subsubjId: -1,
      user_Id: -1,
      fileNo: "",
      subDeptID: -1,
      synopsis: "",
      complt: ""
    }
    console.log("collectData", collectData);

    const response = await axios.post(
      HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
      collectData
    );

    console.log("getData", response.data.data);
    setDocDetailData(response.data.data[0]["fileNo"] + " - " + response.data.data[0]["fileType_Name"])
    setDocDetailRecords(response.data.data);
    setDrawerOpen(true);
  }

  const devId = getSecureDevId();

  const fetchZonesData = async () => {
    try {
      const collectData = {
        docMid: -1,
        fileTypId: -1,
        //@ts-ignore
        divisionid: devId === "null" ? -1 : devId,
        subsubjId: -1,
        user_Id: -1,
        fileNo: "",
        subDeptID: subDeptID == null ? -1 : subDeptID,
        synopsis: "",
        complt: ""
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const zonesWithIds = data.map((doc: any, index: any) => ({
        ...doc,
        serialNo: index + 1,
        id: doc.docMid,
      }));

      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const actionColumn: GridColDef[] =
          permissionData?.isEdit || permissionData?.isDel || permissionData?.isView
            ? [
              {
                field: "actions",
                headerClassName: "MuiDataGrid-colCell",
                headerName: t("text.Action"),
                width: 180,
                renderCell: (params) => (
                  <Stack
                    spacing={1}
                    direction="row"
                    sx={{ alignItems: "center", marginTop: "5px" }}
                  >
                    {permissionData?.isEdit && (
                      <EditIcon
                        style={{ fontSize: "20px", color: "blue", cursor: "pointer" }}
                        onClick={() => routeChangeEdit(params.row)}
                      />
                    )}

                    {permissionData?.isDel && (
                      <DeleteIcon
                        style={{ fontSize: "20px", color: "red", cursor: "pointer" }}
                        onClick={() => handledeleteClick(params.row.id)}
                      />
                    )}

                    {permissionData?.isView && (
                      <VisibilityIcon
                        style={{ fontSize: "20px", color: "#1976d2", cursor: "pointer" }}
                        onClick={() => getDocMngRecords(params.row.id)}
                      />
                    )}
                  </Stack>
                ),
              },
            ]
            : [];

        const columns: GridColDef[] = [
          ...actionColumn,
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 60
          },
          {
            field: "fileNo",
            headerName: t("text.FileNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 140
          },
          {
            field: "synopsis",
            headerName: t("text.FileName"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 140
          },
          {
            field: "fileDef",
            headerName: t("text.FileDef"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            minWidth: 140
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          // border: ".5px solid #FF7722 ",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900
            },
          }}
          style={{ padding: "10px", }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.DocumentEntry")}
          </Typography>
          <Divider />

          <Box height={10} />

      <Stack
  direction={{ xs: "column", sm: "row" }}
  spacing={2}
  sx={{ flexWrap: "wrap" }}
>
  {permissionData?.isAdd && (
    <Button
      onClick={routeChangeAdd}
      variant="contained"
      endIcon={<AddCircleIcon />}
      size="large"
      fullWidth
      sx={{
        width: { xs: "100%", sm: "auto" },
        backgroundColor: `var(--header-background)`
      }}
    >
      {t("text.add")}
    </Button>
  )}

  {permissionData?.isExport && (
    <Button
      component="label"
      variant="contained"
      endIcon={<PublishIcon />}
      size="large"
      fullWidth
      sx={{
        width: { xs: "100%", sm: "auto" },
        backgroundColor: `var(--header-background)`
      }}
    >
      {t("text.ImportExcel")}
      <input type="file" hidden />
    </Button>
  )}

  {permissionData?.isExport && (
    <Button
      onClick={handleDownloadTemplate}
      variant="contained"
      endIcon={<DownloadIcon />}
      size="large"
      fullWidth
      sx={{
        width: { xs: "100%", sm: "auto" },
        backgroundColor: `var(--header-background)`
      }}
    >
      {t("text.DownloadTemplate")}
    </Button>
  )}
</Stack>

          <FileDetailSwipeableDrawer
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            title={`# ${DocDetailData}  `}
            userData={DocDetailRecords}
          />

          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Box>
              <br />
              <div style={{ width: "100%", backgroundColor: `var(--grid-background)` }}>
                <DataGrid
                  rows={zones}
                  columns={adjustedColumns}
                  autoHeight
                  slots={{
                    toolbar: GridToolbar,
                  }}
                  rowSpacingType="border"
                  pagination={true}
                  pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                    value: size,
                    label: `${size}`,
                  }))}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 5 } },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                />
              </div>
            </Box>
          )}
        </Paper>
      </Card>

      <Dialog open={excelModalOpen} onClose={() => setExcelModalOpen(false)}>
        <DialogTitle>Confirm Excel Import</DialogTitle>
        <DialogContent>
          <Typography>
            Selected File: <strong>{selectedExcelFile?.name}</strong>
          </Typography>
          <Typography mt={1}>
            Click <strong>Import</strong> to upload this Excel file.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={() => setExcelModalOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleFinalExcelImport}
            disabled={importLoading}
            style={{ backgroundColor: `var(--header-background)` }}
          >
            {importLoading ? "Importing..." : "Import"}
          </Button>
        </DialogActions>
      </Dialog>

      <ToastApp />
    </>
  );
}
